import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Tube = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 63.8 117.26">
  <G fill={color}>
    <Path d="M11.94,114.35c0,1.61,1.3,2.91,2.91,2.91h34.11c1.61,0,2.91-1.3,2.91-2.91v-4.46H11.94v4.46Z"/>
    <Path d="M59.49,0H4.31C1.93,0,0,1.93,0,4.31v7.21c0,.56.11,1.12.33,1.64,8.34,20.24,10.83,36.7,11.61,76.53,0,0,0,.01,0,.02v16.29h11.16v-2.98c0-.81.66-1.47,1.47-1.47h14.67c.81,0,1.47.66,1.47,1.47v2.98h11.16v-16.81c.79-39.47,3.3-55.87,11.6-76.03.21-.52.33-1.08.33-1.64v-7.21c0-2.38-1.93-4.31-4.31-4.31ZM8.96,11.52h45.87c-7.99,19.93-10.63,36.71-11.51,73.78h-22.86c-.88-37.07-3.51-53.85-11.51-73.78Z"/>
  </G>
</Svg>
);
};

export default Tube;
